<div class="survey-option">
  <div class="pointer">
    <mat-radio-button [disabled]="surveyOptions.disabled"></mat-radio-button>
  </div>
  <div [formGroup]="parentForm" class="input-filed">
    <itb-input
      [formFieldName]="formFieldName"
      [parentForm]="parentForm"
      [label]="surveyOptions.label"
      (onChangeHandler)="onSubmit(parentForm.value)"
      [placeholder]="surveyOptions.placeholder"
      [type]="surveyOptions.type"
      [maxlength]="30"
    ></itb-input>
  </div>
  <div class="btn-cont">
    <itb-icon
      [hidden]="isDisabled"
      [tooltipText]="surveyOptions.tooltipText"
      [className]="surveyOptions.iconClassName"
      (onClickHandler)="onDelete($event)"
    ></itb-icon>
  </div>
</div>
